export default {
  routes: [
    /*  登录页 */
    {
      path: "/",
      name: "Login",
      meta: {
        auth: true,
      },
      component: () => import("@/view/login/index.vue"),
    },
    /* 管理端 */
    {
      path: "/management",
      name: "Management",
      component: () => import("@/view/management/index.vue"),
      // redirect: "/management/supAdmin", //重定向到第一个子路由
      children: [

        /* 欢迎页*/
        {
          path: "welcome",
          name: "Welcome",
          component: () => import("@/view/management/welcome/index.vue"),
        },

        /* 系统管理 */
        {
          path: "system",
          component: () =>
            import("@/view/management/system/index.vue"),
          children: [{
            path: "user",
            name: "SysUser",
            component: () =>
              import("@/view/management/system/user/index.vue"),
          },
          {
            path: "authGroup",
            name: "AuthGroup",
            component: () =>
              import(
                "@/view/management/system/authGroup/index.vue"
              ),
          },
          {
            path: "menu",
            name: "Menu",
            component: () =>
              import("@/view/management/system/menu/index.vue"),
          },
          {
            path: "log",
            name: "Log",
            component: () =>
              import("@/view/management/system/log/index.vue"),
          },
          ],
        },
        //商家-管理账号权限
        {
          path: "myPermission",
          name: "MyPermission",
          component: () => import("@/view/management/myPermission/index.vue"),
          children: [{
            path: "user",
            name: "MyPermissionUser",
            component: () =>
              import("@/view/management/myPermission/user/index.vue"),
          },
          {
            path: "authGroup",
            name: "MyPermissionAuthGroup",
            component: () =>
              import("@/view/management/myPermission/authGroup/index.vue"),
          },
          ],
        },
        /* 小程序管理 */
        {
          path: "miniApp",
          component: () => import("@/view/management/miniApp/index.vue"),
          children: [
            /* 首页-数据面板 */
            {
              path: "dashboard",
              name: "Dashboard",
              component: () => import("@/view/management/miniApp/dashboard"),
            },
            {
              path: "user",
              name: "MallUser",
              component: () =>
                import("@/view/management/miniApp/user/index.vue"),
            },
            {
              path: "dakaRecord",
              name: "DakaRecord",
              component: () =>
                import("@/view/management/miniApp/dakaRecord/index.vue"),
            },
            {
              path: "store",
              name: "MallStore",
              component: () =>
                import("@/view/management/miniApp/store/index.vue"),
            },
            {
              path: "banner",
              name: "MiniAppBanner",
              component: () =>
                import("@/view/management/miniApp/banner/index.vue"),
            },
            {
              path: "article",
              name: "MiniAppArticle",
              component: () =>
                import("@/view/management/miniApp/article/index.vue"),
            }
          ]
        },

        /* 门店管理 */
        {
          path: "store",
          name: "Store",
          component: () => import("@/view/management/store/index.vue"),
          children: [{
            path: "storeList",
            name: "StoreList",
            component: () =>
              import("@/view/management/store/storeList/index.vue"),
          },
          {
            path: "staff",
            name: "Staff",
            component: () =>
              import("@/view/management/store/staff/index.vue"),
          },
          {
            path: "goods",
            name: "Goods",
            component: () =>
              import("@/view/management/store/goods/index.vue"),
            children: [{
              path: "goodsKind",
              name: "GoodsKind",
              component: () =>
                import("@/view/management/store/goods/goodsKind/index.vue"),
            },
            {
              path: "goodsList",
              name: "GoodsList",
              component: () =>
                import("@/view/management/store/goods/goodsList/index.vue"),
            },
            ],
          },
          {
            path: "mallGoods",
            name: "MallGoods",
            component: () =>
              import("@/view/management/store/mallGoods/index.vue"),
            children: [{
              path: "goodsKind",
              name: "MallGoodsKind",
              component: () =>
                import(
                  "@/view/management/store/mallGoods/goodsKind/index.vue"
                ),
            },
            {
              path: "goodsList",
              name: "MallGoodsList",
              component: () =>
                import(
                  "@/view/management/store/mallGoods/goodsList/index.vue"
                ),
            },
            ],
          },
          {
            path: "mallGoodsBusiness",
            name: "MallGoodsBusiness",
            component: () =>
              import("@/view/management/store/mallGoodsBusiness/index.vue"),
            children: [{
              path: "goodsKind",
              name: "MallGoodsBusinessGoodsKind",
              component: () =>
                import(
                  "@/view/management/store/mallGoodsBusiness/goodsKind/index.vue"
                ),
            },
            {
              path: "goodsList",
              name: "MallGoodsBusinessGoodsList",
              component: () =>
                import(
                  "@/view/management/store/mallGoodsBusiness/goodsList/index.vue"
                ),
            },
            ],
          },
          {
            path: "integralGoods",
            name: "IntegralGoods",
            component: () =>
              import("@/view/management/store/integralGoods/index.vue"),
            children: [{
              path: "goodsKind",
              name: "IntegralGoodsKind",
              component: () =>
                import(
                  "@/view/management/store/integralGoods/goodsKind/index.vue"
                ),
            },
            {
              path: "goodsList",
              name: "IntegralGoodsList",
              component: () =>
                import(
                  "@/view/management/store/integralGoods/goodsList/index.vue"
                ),
            },
            ],
          },


          /* 门店会员订单 */
          {
            path: "order",
            name: "Order",
            component: () => import("@/view/management/store/order/index.vue"),
          },

          ],
        },

        {
          path: "couponList",
          name: "CouponList",
          component: () =>
            import("@/view/management/coupon_list/index.vue"),
        },
        {
          path: "couponCard",
          name: "CouponCard",
          component: () =>
            import("@/view/management/coupon_card/index.vue"),
        },
        /* 会员管理 */
        {
          path: "vipCard",
          name: "MallVipCard",
          component: () => import("@/view/management/vipCard"),
          children: [{
            path: "vipCardList",
            name: "MallVipCardList",
            component: () => import("@/view/management/vipCard/vipCardList"),
          },
          {
            path: "vipCardRecode",
            name: "MallVipCardRecode",
            component: () =>
              import("@/view/management/vipCard/vipCardRecode"),
          },
          ],
        },

        /* api */
        {
          path: "doc",
          // name: "Person",
          component: () => import("@/view/management/doc/index.vue"),
          children: [{
            path: "goods",
            name: "DocGoods",
            component: () =>
              import("@/view/management/doc/goods/index.vue"),
          },],
        },

        /* 个人页 */
        {
          path: "person",
          // name: "Person",
          component: () => import("@/view/management/person/index.vue"),
          children: [{
            path: "center",
            name: "PersonCenter",
            component: () =>
              import("@/view/management/person/center/index.vue"),
          },],
        },
      ],
    },
    /* 其他页 */
    {
      path: "/errow",
      name: "Errow",
      component: () => import("@/view/error/index.vue"),
    },
  ],
  // mode: "history",
  mode: "hash",
};